import { useEffect, useState } from "react";
import API from "../../../api";
import { Box, Typography, List, ListItem, Divider } from "@mui/material";
import CircularIndeterminate from "./../../../components/circularProgress";

const NetworkList = ({names}) => {

    const [data, setData] = useState([]);
    const [load, setLoad] = useState(true);

    useEffect(() => {
        setLoad(false);
        API.getWeeklyDataLecs({ queryType: "network"}).then((result) => {
            const temp = result.data.map((item) => {
                const name = names.find((name) => name.seriale === item.fkSeriale);
                return{
                    lecs: name.nomeLecs || name.matricola,
                    networkNoise: item.avgNetworkNoise,
                    bps: item.avgBps
                }
            });
            setData(temp);
            setLoad(false);
        }).catch((err) => console.error("[NetworkList] Errore durante il recupero dei dati di rete:", err));
    }, [names]);

    return (
        <>
            <Typography variant="h3" sx={{ mb: 2}}>Network List</Typography>
            <Box className="networkList" sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                border: "3px solid #449095",
                background: "#1E1E1E",
                borderRadius: "15px",
                height: "100%",
                px: 2
            }}>
                {!load ? (
                <List sx={{
                    width: "100%",
                    height: "100%",
                }}>
                    {data.map((item) => (
                        <ListItem key={item.lecs} sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            border: "solid 1px #459095",
                            borderRadius: 5,
                            mt: 1
                        }}>
                            <Typography variant="h5" sx={{textAlign: "center"}}>{"Lecs: "+item.lecs}</Typography>
                            <Divider orientation="horizontal" sx={{width: "100%", my: 1, fontWeight: 600}}/>
                            <Box display={"flex"} gap={5}>
                            <Typography>{"Noise: "+item.networkNoise}</Typography>
                            <Typography>{"Bps: "+item.bps}</Typography>
                            </Box>
                        </ListItem>
                    ))}
                </List>
                ) : (
                    <Box sx={{ width: "100%", height: "100%",}}>
                        <CircularIndeterminate charged={false}/>
                    </Box>
                )}
            </Box>
        </>
    );
}

export default NetworkList;
